import HTTP_GESCOM from '../HTTP_GESCOM';
import gestionErreur from '@/services/general/gestionErreur';

const URL_BASE_SOCIETE = 'commun/Societe/';
const URL_BASE_SUPPORT_COMMERCIAL = 'gescom/SupportCommercial/';

export async function GetSupportCommercialAsync(idSociete) {
  try {
    const response = await HTTP_GESCOM.post(URL_BASE_SUPPORT_COMMERCIAL + 'PGetAllAsync', {
      SkipCount: 0,
      MaxResultCount: 9999999,
      Query: {
        societeId: idSociete,
        filteredByModule: true,
      },
    });
    return response;
  } catch (e) {
    gestionErreur('Erreur lors de la récupération du support commercial', e);
  }
}

export async function getSocieteUser(idSociete) {
  try {
    const response = await HTTP_GESCOM.get(URL_BASE_SOCIETE + 'GetAsync', {
      params: { id: idSociete },
    });
    return response.data.result;
  } catch (e) {
    gestionErreur('Erreur lors de la récupération de la societe du user', e);
  }
}

export async function getAllSocietes() {
  const response = await HTTP_GESCOM.post('commun/Societe/PGetAllAsync', {
    SkipCount: 0,
    MaxResultCount: 9999999,
  });
  const { result } = response.data;
  return { data: result.items };
}
